import { MultiImageDownloadRepository } from '@aipb/gulliver/catalog/data-access';
import { createDetailCompositeKey } from '@aipb/gulliver/catalog/util';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input, OnChanges, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { combineLatest, Observable, of } from 'rxjs';
import { MatIconModule } from '@angular/material/icon';

interface MultiImageDownloadCheckboxVM {
  active: boolean;
  checked: boolean;
  canToggleChecked: boolean;
  downloadInProgress: boolean;
}

@Component({
  selector: 'cat-multi-image-download-checkbox',
  templateUrl: './multi-image-download-checkbox.component.html',
  styleUrls: ['./multi-image-download-checkbox.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule]
})
export class MultiImageDownloadCheckboxComponent implements OnInit, OnChanges {
  @Input() recordId: string;
  @Input() coreId: string;
  @Input() image: string;
  @Input() title: string;
  @Input() type: string;

  vm$: Observable<MultiImageDownloadCheckboxVM> = of({
    active: false,
    checked: false,
    canToggleChecked: false,
    downloadInProgress: false
  });
  private multiImageDownloadRepository = inject(MultiImageDownloadRepository);

  ngOnInit() {
    this.vm$ = combineLatest({
      checked: this.multiImageDownloadRepository.selectChecked({
        id: createDetailCompositeKey(this.coreId, this.recordId),
        image: this.image,
        title: this.title,
        type: this.type
      }),
      active: this.multiImageDownloadRepository.active$,
      canToggleChecked: this.multiImageDownloadRepository.canToggleChecked$,
      downloadInProgress: this.multiImageDownloadRepository.downloadInProgress$
    });
  }

  ngOnChanges() {
    this.vm$ = combineLatest({
      checked: this.multiImageDownloadRepository.selectChecked({
        id: createDetailCompositeKey(this.coreId, this.recordId),
        image: this.image,
        title: this.title,
        type: this.type
      }),
      active: this.multiImageDownloadRepository.active$,
      canToggleChecked: this.multiImageDownloadRepository.canToggleChecked$,
      downloadInProgress: this.multiImageDownloadRepository.downloadInProgress$
    });
  }

  onToggleChecked(evt): void {
    evt.stopPropagation();
    this.multiImageDownloadRepository.toggleChecked({
      id: createDetailCompositeKey(this.coreId, this.recordId),
      image: this.image,
      title: this.title,
      type: this.type
    });
  }
}
